import { cx } from '@/utils/cx';

const variantBg = {
  brand: 'bg-bg-brand-primary',
  warning: 'bg-warning-primary',
  success: 'bg-success-primary',
} as const;

const ariaRole = {
  brand: 'status',
  warning: 'alert',
  success: 'status',
} as const;

interface BaseBannerProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  message: React.ReactNode;
  action?: React.ReactNode;
  variant?: keyof typeof variantBg;
  className?: string;
}

export function BaseBanner({
  icon,
  title,
  message,
  action,
  variant = 'brand',
  className,
}: BaseBannerProps) {
  return (
    <div
      role={ariaRole[variant]}
      className={cx(
        'flex items-start gap-6 rounded-xl p-4 lg:p-6',
        variantBg[variant],
        className,
      )}
    >
      {icon && <div className="hidden shrink-0 lg:flex">{icon}</div>}
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <div className="flex flex-row items-center gap-4 text-lg font-semibold text-primary">
          {icon && <div className="lg:hidden">{icon}</div>}
          {title}
        </div>
        <div className="text-sm text-secondary">{message}</div>
        {action}
      </div>
    </div>
  );
}
